
import objectAssign from 'object-assign'
import SirTrevor from 'sir-trevor';

export default (function(){

  const templateHTML = (data) => `
    <div class="st-image">
      <img src="${data.file.url}" class="st-image__img" />
      <div class="st-image__meta">
        <div class="st-image__meta-item">
          <div class="st-image__meta-item-label">Add external link (optional)</div>
          <input type="text" name="link_url" class="js-link-url" value="${data.link_url}" />
        </div>
      </div>
    </div>
  `;

  const defaultData = {
    file: {
      url: ""
    },
    link_url: ""
  };

  return SirTrevor.Block.extend({

    type: "image",
    title: function() { return i18n.t('blocks:image:title'); },

    droppable: true,
    uploadable: true,

    icon_name: 'image',

    validations: ['urlValidator'],

    loadData: function(data) {
      data = objectAssign(defaultData, data);

      this.inputs.style.display = 'none';
      this.editor.innerHTML = "";
      this.editor.insertAdjacentHTML("beforeend", templateHTML(data));
      this.editor.style.display = '';
    },

    onDrop: function(transferData) {
      var file = transferData.files[0],
          urlAPI = (typeof URL !== "undefined") ? URL : (typeof webkitURL !== "undefined") ? webkitURL : null;

      // Handle one upload at a time
      if (/image/.test(file.type)) {
        this.loading();

        this.loadData({
          file: {
            url: urlAPI.createObjectURL(file)
          }
        });

        this.uploader(
          file,
          function(data) {
            this.setData(data);
            this.ready();
          },
          function(error) {
            this.addMessage(i18n.t('blocks:image:upload_error'));
            this.ready();
          }
        );
      }
    },

    urlValidator: function() {
      var urlField = this.el.querySelector('.js-link-url');
      if (urlField.value !== "" && !/^https?:\/\//i.test(urlField.value)) {
        urlField.value = 'http://' + urlField.value;
      }
    }
  })
})();
